module.exports = __webpack_public_path__ + "static/media/property-managers-2.0ae87fc6.svg";